// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.3.0",
    "short": "d37a547",
    "branch": "Detached: d37a5476346bc7cf6f64048c29daca184d4a14dd",
    "date": "2026-7-21"
};
/* eslint:enable */
